import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Classes from "./Forms.module.css";
import Sidebar from "./Components/Sidebar/Sidebar";
import { useSelector } from "react-redux";
import Intake from "./Components/Intake/Intake";

export default function Forms() {
    const navigateTo = useNavigate();
    const [activeTab, setActiveTab] = useState("intake");
    const companyInfo = useSelector((state) => state.companyInfo?.info);
    const [colorScheme, setcolorScheme] = useState(companyInfo?.color);

    return (
        <div className={Classes.container}>
            <div className={Classes.header}>
                <div>
                    <h3>Forms</h3>
                    <h5>Create and edit different forms for your clients.</h5>
                </div>
            </div>

            <div className={Classes.hero} >
                <div className={Classes.heroLeft}>
                    <Sidebar activeTab={activeTab} setActiveTab={setActiveTab} />
                </div>
                <div className={Classes.heroRight} >

                    {activeTab === "intake" && <Intake />}

                </div>
            </div>

        </div>
    );
}